function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M462.697 501.463H327.068c-21.706 0-39.303-17.597-39.303-39.303V326.52c0-21.706 17.597-39.303 39.303-39.303h135.629c21.706 0 39.303 17.597 39.303 39.303v135.64c0 21.707-17.597 39.303-39.303 39.303z",
    style: {},
    fill: "#bc9af4",
    "data-original": "#bc9af4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.323 353.535c0-23.83 5.603-46.351 15.561-66.318h-42.769c-21.733 0-39.351 17.619-39.351 39.353v135.54c0 21.734 17.618 39.353 39.351 39.353h135.533c4.187 0 8.22-.654 12.005-1.866-68.559-13.272-120.33-73.621-120.33-146.062z",
    style: {},
    fill: "#6864f7",
    "data-original": "#6864f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.697 224.782H327.068c-21.706 0-39.303-17.597-39.303-39.303V49.84c0-21.706 17.597-39.303 39.303-39.303h135.629C484.403 10.537 502 28.133 502 49.84v135.64c0 21.706-17.597 39.302-39.303 39.302z",
    style: {},
    fill: "#67ccd1",
    "data-original": "#67ccd1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.323 76.855c0-23.83 5.603-46.351 15.561-66.318h-42.769c-21.733 0-39.351 17.619-39.351 39.353v135.54c0 21.734 17.618 39.353 39.351 39.353h135.533c4.187 0 8.22-.654 12.005-1.866-68.559-13.273-120.33-73.621-120.33-146.062z",
    style: {},
    fill: "#27a2cc",
    "data-original": "#27a2cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.932 501.463H49.303C27.597 501.463 10 483.867 10 462.16V326.52c0-21.706 17.597-39.303 39.303-39.303h135.629c21.706 0 39.303 17.597 39.303 39.303v135.64c0 21.707-17.597 39.303-39.303 39.303z",
    style: {},
    fill: "#67ccd1",
    "data-original": "#67ccd1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.558 353.535c0-23.83 5.603-46.351 15.561-66.318H49.351C27.618 287.218 10 304.837 10 326.571v135.54c0 21.734 17.618 39.353 39.351 39.353h135.533c4.187 0 8.22-.654 12.005-1.866-68.56-13.273-120.331-73.622-120.331-146.063z",
    style: {},
    fill: "#27a2cc",
    "data-original": "#27a2cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.249 224.782h-.263C57.899 224.782 10 176.883 10 117.796v-.273C10 58.436 57.899 10.537 116.986 10.537h.263c59.087 0 106.986 47.899 106.986 106.986v.273c0 59.087-47.899 106.986-106.986 106.986z",
    style: {},
    fill: "#fdcb50",
    "data-original": "#fdcb50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.134 78.072c0-22.182 5.839-43.001 16.064-61.002C39.229 32.112 10 71.472 10 117.659c0 59.162 47.958 107.123 107.117 107.123 25.1 0 48.184-8.634 66.444-23.094-66.337-2.243-119.427-56.729-119.427-123.616z",
    style: {},
    fill: "#fd8f01",
    "data-original": "#fd8f01",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.697 224.782H327.068c-21.706 0-39.303-17.597-39.303-39.303V49.84c0-21.706 17.597-39.303 39.303-39.303h135.629C484.403 10.537 502 28.133 502 49.84v135.64c0 21.706-17.597 39.302-39.303 39.302zM117.249 224.782h-.263C57.899 224.782 10 176.883 10 117.796v-.273C10 58.436 57.899 10.537 116.986 10.537h.263c59.087 0 106.986 47.899 106.986 106.986v.273c0 59.087-47.899 106.986-106.986 106.986zM462.697 501.463H327.068c-21.706 0-39.303-17.597-39.303-39.303V326.52c0-21.706 17.597-39.303 39.303-39.303h135.629c21.706 0 39.303 17.597 39.303 39.303v135.64c0 21.707-17.597 39.303-39.303 39.303zM184.932 501.463H49.303C27.597 501.463 10 483.867 10 462.16V326.52c0-21.706 17.597-39.303 39.303-39.303h135.629c21.706 0 39.303 17.597 39.303 39.303v135.64c0 21.707-17.597 39.303-39.303 39.303z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#052a75",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#052a75",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.118 84.813v65.693M149.962 117.66H84.273",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ffffff",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.bd5ee4d2940419df336a6383e3551a87.svg";
export { ForwardRef as ReactComponent };